import { ChevronDownIcon } from '@assets/icons/ChevronIcon';
import { cn } from '@components/shadcn/utils';
import { selectRegion } from '@state/regions/region.selectors';
import { useBoundStore } from '@state/store';
import { Popover } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RegionTree } from './RegionTree';

export const RegionPicker = () => {
  const { t } = useTranslation();
  const selectedRegion = useBoundStore(selectRegion);
  const { regionTree } = useBoundStore((state) => state.regions);

  const [regionPopoverVisible, setRegionPopoverVisible] = useState(false);

  return (
    <Popover
      trigger={['click']}
      visible={regionPopoverVisible}
      onVisibleChange={(visible) => setRegionPopoverVisible(visible)}
      content={<RegionTree />}
      placement="bottomLeft"
      overlayClassName={
        'p-0 [&_.ant-popover-arrow]:hidden [&_.ant-popover-inner]:rounded-md [&_.ant-popover-inner-content]:p-1'
      }
      align={{ offset: [0, 8] }}
    >
      <div
        className={'flex items-center py-1 px-2 gap-1 rounded cursor-pointer hover:bg-sy-blue-20'}
      >
        <div className={'flex flex-col'}>
          <span className="text-xs text-sy-neutral-60 truncate">{t('header.regions.region')}</span>
          <span
            className="typo typo--paragraph-1 typo--bold typo--primary typo--nowrap"
            data-testid="region-picker-selected-region"
          >
            {selectedRegion?.id === regionTree?.id ? t('header.regions.all') : selectedRegion?.name}
          </span>
        </div>
        <span
          className={cn('self-end pb-[1px] transition', { ['rotate-180']: regionPopoverVisible })}
        >
          <ChevronDownIcon />
        </span>
      </div>
    </Popover>
  );
};

export default RegionPicker;
